import { browser, util as hybridUtil } from '../ws-hybrid';
import { util } from '../ws-common';
import { getQueryObj } from '../ws-util/url';
/**
 * 微视 SchemaBase 类
 * @class WsSchemaBase
 */
export default class WsSchemaBase {
  /**
   * 是否能打开 schema
   * @returns {Boolean}
   * @method
   */
  canOpenSchema() {
    return browser.isMobile && browser.client !== 'wb';
  }

  /**
   * 添加 logsour 参数
   * @param {String} schema
   * @method
   */
  addLogSour(schema) {
    const attachInfo = util.getAttachInfo();
    if (!attachInfo.reserves3) {
      return schema;
    }
    if (/logsour=/ig.test(schema)) {
      return schema;
    }
    const suffix = ~schema.indexOf('?') ? '&' : '?';
    return `${schema + suffix}logsour=${attachInfo.reserves3}`;
  }

  /**
   * 添加 h5_data_report 参数
   * @param {String} schema
   * @method
   */
  addH5DataReport(schema) {
    if (/h5_data_report=/ig.test(schema)) {
      return schema;
    }
    const r = new RegExp('(\\?|#|&)h5_data_report=(.*?)(&|#|$)');
    const m = (window.location.href || '').match(r);
    const H5DATAREPORT = decodeURIComponent(m ? m[2] : '');
    if (!H5DATAREPORT) {
      return schema;
    }
    const suffix = ~schema.indexOf('?') ? '&' : '?';
    return `${schema + suffix}h5_data_report=${encodeURIComponent(H5DATAREPORT)}`;
  }

  /**
   * 给 jump_url 添加 page_where 参数
   * @param {String} schema
   * @method
   */
  addXlightFlag(scheme) {
    const idx = scheme.indexOf('weishi://webview?jump_url=');
    if (idx === -1) {
      return scheme;
    }
    const { jump_url } = hybridUtil.getQueryObj(scheme);
    const newUrl = hybridUtil.appendUrlParam(decodeURIComponent(jump_url), { page_where: 1 });
    // 除了 jump_url 还有别的参数
    if (scheme.indexOf('&') !== -1) {
      return scheme.replace(/\?jump_url=.+?&/, `?jump_url=${encodeURIComponent(newUrl)}&`);
    }
    // 除了 jump_url 没有别的参数
    return `weishi://webview?jump_url=${encodeURIComponent(newUrl)}`;
  };

  /**
   * schema 映射
   * @param {String} schema
   * @param {Object} options
   * @method
   */
  pingSchema(schema, options) {
    const map = {
      recommend: 'weishi://main?goto=recommend',
      // eslint-disable-next-line max-len
      feed:
        'weishi://feed?feed_id={feed_id}&topic_id={topic_id}&person_id={person_id}&polyId={polyId}&update={update}&detail={detail}',
      camera:
        'weishi://camera?camera_follow_shot={camera_follow_shot}&feed_id={feed_id}&topic_id={topic_id}',
      topic: 'weishi://topic?topic_id={topic_id}',
      music: 'weishi://musiccollec?musicid={music_id}',
      geo: 'weishi://geocollec?geo_id={geo_id}',
      person: 'weishi://profile?person_id={person_id}',
      personal: 'weishi://profile?person_id={person_id}',
      personality: 'weishi://profile?person_id={person_id}',
      acttogether: 'weishi://acttogether?polyId={polyId}&update=1',
      acttogethercamera:
        'weishi://acttogether?type={type}&feed_id={feed_id}&source={source}&needlogin=1',
      webview:
        'weishi://webview?jump_url={jump_url}&needlogin={needlogin}&navstyle={navstyle}&_wv={_wv}',
    }; /** remove  it temporarily &detail=1 */

    const needReplace = [
      'feed_id',
      'topic_id',
      'music_id',
      'geo_id',
      'person_id',
      'camera_follow_shot',
      'jump_url',
      'needlogin',
      'navstyle',
      '_wv',
      'polyId',
      'update',
      'detail',
      'type',
      'source',
    ];

    if (!map[schema]) {
      return map.camera;
    }

    // 修复一些参数
    let opts = options || {};
    if (
      schema === 'feed'
      && (opts.topic_id
        || opts.person_id
        || opts.polyId
        || browser.client === 'ws')
    ) {
      opts.detail = 1;
      opts.update = 1;
    }
    if (schema === 'webview' && opts.jump_url) {
      // 自动从jump_url里解析几个参数
      const query = getQueryObj(opts.jump_url) || {};
      const autoOpt = {
        needlogin: query.needlogin,
        navstyle: query.navstyle,
        // eslint-disable-next-line
        _wv: query._wv,
      };
      opts = Object.assign(autoOpt, opts);
    }

    // 参数替换
    needReplace.forEach((replace) => {
      if (opts[replace]) {
        const aux = replace === 'jump_url' ? _ => encodeURIComponent(_) : _ => _;
        map[schema] = map[schema].replace(`{${replace}}`, aux(opts[replace]));
      } else {
        map[schema] = map[schema].replace(
          new RegExp(`${replace}={${replace}}&?`),
          '',
        );
      }
    });

    // 替换最后的问号
    // eslint-disable-next-line no-useless-escape
    map[schema] = map[schema].replace(/[\?&]+$/, '');
    return map[schema];
  }

  /**
   * schema 格式化
   * @param {String} schema
   * @param {Object} opts
   * @method
   */
  formatSchema(schema, opts) {
    let newSchema = schema;
    // 说明不是是完整的schema地址
    if (!~schema.indexOf('://')) {
      newSchema = this.pingSchema(schema, opts);
    }

    newSchema = this.addLogSour(newSchema);
    newSchema = this.addH5DataReport(newSchema);

    return newSchema;
  }

  /**
   * url 格式化
   * @param {String} url
   * @param {Object} opt
   * @method
   */
  formatUrl(url, opt) {
    // 如果是跳转play页面就要跳相应聚合页的播放页
    if (url && /[^?]*weishi\/play\//.test(url)) {
      if (opt.person_id) return `${url}&mode=personal&modeId=${opt.person_id}`;

      if (opt.topic_id) return `${url}&mode=topic&modeId=${opt.topic_id}`;

      if (opt.music_id) return `${url}&mode=music&modeId=${opt.music_id}`;

      if (opt.geo_id) return `${url}&mode=geo&modeId=${opt.geo_id}`;
    }

    return url;
  }

  // eslint-disable-next-line no-unused-vars
  openGeneralUrlScheme(url, params) {
    return true;
  }
}

// export default new WsSchemaBase();
